import { useCallback } from 'react';
import { useRegisterContentEngagementMutation } from '../../../../__generated__/chirp/com/hubspot/academy/recommendations/rpc/ranked/RankedRecommendationService.hooks';
import Raven from 'raven-js';
export const usePostRankedRecommendationsContentEngagedFeedback = () => {
  const [mutate, {
    error: postRankedRecommendationsContentEngagedFeedbackError,
    loading: postRankedRecommendationsContentEngagedFeedbackLoading
  }] = useRegisterContentEngagementMutation();
  const postRankedRecommendationsContentEngagedFeedback = useCallback(variables => {
    return mutate({
      variables,
      onError(error) {
        Raven.captureException(error);
      }
    });
  }, [mutate]);
  return {
    postRankedRecommendationsContentEngagedFeedback,
    postRankedRecommendationsContentEngagedFeedbackError,
    postRankedRecommendationsContentEngagedFeedbackLoading
  };
};